export const siteUrl = (fullUrl, requestType) => {
  if( fullUrl.includes('dev.') && (requestType === 'expressJS') ){
    // Dev SPP Data Hub
    return 'http://dev.statplatform.sportspassports.com:7000';
  }else{
    return 'https://spdatahub.sportspassports.com';
//     return 'https://datahub.sportspassports.com';
  }
}